__webpack_require__.p = "https://media-assets.swiggy.com/portal-static-page/_next/";